// extracted by mini-css-extract-plugin
export default {"title":"InjuryRegistrationModal_title__Xuvcb","footer":"InjuryRegistrationModal_footer__xCVm1"};